/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react-hooks/exhaustive-deps */
import { useForm, Controller } from "react-hook-form";
import {
  Flex,
  Heading,
  Button,
  FormControl,
  FormLabel,
} from "@chakra-ui/react";
import { MultiSelect } from "@progress/kendo-react-dropdowns";
import { useEffect, useState } from "react";
import FormInput from "../../../components/forms/form-Input";
import {
  CASH_CENTER_STATUS,
  CASH_CENTER_TYPES,
  LOADING_BAY_AREAS,
  WEEK_DAYS,
} from "../constants";
import NumericInput from "../../../components/forms/react-hook-numeric-input";
import FormHookDatePicker from "../../../components/forms/form-hook-date-picker";
import ReactHookFormDropdown from "../../../components/forms/react-hook-dropdown";
import { useGetCashCenterListPaginated } from "../../../services/cash-center";

import {
  useLookupCities,
  useLookupCountries,
  useLookupEmirates,
  useLookupRegions,
} from "../../../services/lookups-mutations";
import { useLookupEmployees } from "services/lookups-queries";
import { Textarea } from "@repo/ui";
import { useGetUsersList } from "services/auth-api";

export default function Information({
  // cashCenterInformation,
  currencies,
  onNextStep,
  handleSubmit,
  control,
  errors,
  watch,
  resetField,
  setValue,
  getValues,
  // setError,
  isValid,
}) {
  const { mutate: getCountries, data: countriesListRes } = useLookupCountries();
  const { mutate: getRegions, data: regionsListRes } = useLookupRegions();
  const { mutate: getEmirates, data: emiratesListRes } = useLookupEmirates();
  const { data: employees, mutate: getUsersList } = useGetUsersList();
  const { mutate: getCities, data: citiesListRes } = useLookupCities();
  const generalFieldProps = { control, errors };
  const { setError } = generalFieldProps.control;

  const [cashCenters, setCashCenters] = useState([]);
  const {
    mutate: getCashCenterList,
    isSuccess: cashCenterListAvailable,
    data: cashCenterList,
    isPending: gettingCashCenterList,
    reset: resetCashCenterList,
  } = useGetCashCenterListPaginated();

  useEffect(() => {
    if (cashCenterListAvailable) {
      setCashCenters(cashCenterList.data.data);
      resetCashCenterList();
    }
  }, [cashCenterListAvailable]);

  useEffect(() => {
    getUsersList();
    getCashCenterList({
      pageNumber: 1,
      pageRowCount: 1000,
      searchCriteria: "",
      operationDate: new Date(),
    });
  }, []);

  const handleBarCodeBlur = (e) => {
    const trimmed = e.target.value.trim();
    const currentLocationId = getValues("locationId");

    const duplicate = cashCenters.find(
      (location) =>
        location.barcode?.trim().toLowerCase() === trimmed.toLowerCase() &&
        location.locationId !== currentLocationId,
    );

    if (duplicate) {
      setError("barcode", {
        type: "manual",
        message: "This barcode already exists for another location.",
      });
      setValue("barcode", ""); // clear field
    } else {
      setValue("barcode", trimmed, {
        shouldValidate: true,
        shouldDirty: true,
      });
    }
  };

  const formValidationRules = {
    name: { required: "Please Enter Name" },
    type: { required: "Please Select Type" },
    primaryCurrency: { required: "Please Select Currency" },
    barcode: { required: "Please Enter Barcode" },
    locationId: { required: "Please Enter Location" },
    status: { required: "Please Select Status" },
  };

  const handleTrimOnBlur = (field) => (e) => {
    const trimmed = e.target.value.trim();
    setValue(field, trimmed, {
      shouldValidate: true,
      shouldDirty: true,
    });
  };

  const handleCountryChange = () => {
    setValue("state", "");
    setValue("city", "");
    setValue("emirate", "");
  };

  const handleLoadingBayChange = (value) => {
    if (value === "0") {
      resetField("loadingBayCapacity");
    }
  };

  useEffect(() => {
    getCountries();
  }, []);

  useEffect(() => {
    const countryName = watch("country");
    const country = countriesListRes?.data.find(
      (elm) => elm.name === countryName,
    );
    if (country) {
      const countryCode = country.code;
      getRegions(countryCode);
      getCities(countryCode);
      getEmirates(countryCode);
    }
  }, [watch("country")]);

  const handleNextClick = () => {
    const barcode = getValues("barcode");
    if (barcode) {
      handleBarCodeBlur({ target: { value: barcode } });
    }

    const barcodeError = errors?.barcode?.message;
    if (barcodeError) return;

    handleSubmit(onNextStep)();
  };

  return (
    <>
      <Flex w="100%" justify="space-between" flexDirection="row">
        <Heading style={{ width: "100%" }}>Cash Center Information</Heading>
        <Flex w="100%" justify="flex-end" flexDirection="row">
          <Button isDisabled={!isValid} type="button" onClick={handleNextClick}>
            Next
          </Button>
        </Flex>
      </Flex>

      <FormInput
        {...generalFieldProps}
        isRequired
        label="Name"
        name="name"
        rules={formValidationRules.name}
      />
      <ReactHookFormDropdown
        {...generalFieldProps}
        isRequired
        label="Type"
        name="type"
        placeholder="Select Type"
        data={CASH_CENTER_TYPES}
        rules={formValidationRules.type}
      />
      <ReactHookFormDropdown
        {...generalFieldProps}
        isRequired
        label="Primary Currency"
        name="primaryCurrency"
        placeholder="Select Currency"
        data={
          currencies.map((item) => ({
            value: item.shortName,
            label: item.name,
          })) || []
        }
        rules={formValidationRules.primaryCurrency}
      />
      <FormInput
        {...generalFieldProps}
        isRequired
        label="Barcode"
        name="barcode"
        rules={formValidationRules.barcode}
        onBlur={handleBarCodeBlur}
      />
      <FormInput
        {...generalFieldProps}
        isRequired
        label="Location Id"
        name="locationId"
        rules={formValidationRules.locationId}
        onBlur={handleTrimOnBlur("locationId")}
      />
      <ReactHookFormDropdown
        {...generalFieldProps}
        isRequired
        label="Status"
        name="status"
        placeholder="Select Status"
        data={CASH_CENTER_STATUS}
        rules={formValidationRules.status}
      />
      <NumericInput {...generalFieldProps} label="Longitude" name="longitude" />
      <NumericInput {...generalFieldProps} label="Latitude" name="latitude" />

      <ReactHookFormDropdown
        {...generalFieldProps}
        label="Loading Bay Area"
        name="loadingBayArea"
        placeholder="Select Area"
        data={LOADING_BAY_AREAS}
        onChange={handleLoadingBayChange}
      />
      <NumericInput
        {...generalFieldProps}
        disabled={!watch("loadingBayArea")}
        label="Loading Bay Capacity"
        name="loadingBayCapacity"
        info={
          !watch("loadingBayArea") ? "Select Loading Bay Area To Enable" : ""
        }
      />

      <ReactHookFormDropdown
        {...generalFieldProps}
        label="Country"
        name="country"
        placeholder="Select Country"
        data={
          countriesListRes?.data.map((item) => ({
            label: item.name,
            value: item.name,
          })) || []
        }
        onChange={handleCountryChange}
      />
      <ReactHookFormDropdown
        {...generalFieldProps}
        disabled={!watch("country")}
        label="State"
        name="state"
        placeholder="Select State"
        data={
          regionsListRes?.data.map((item) => ({
            label: item.name,
            value: item.name,
          })) || []
        }
        info={!watch("country") ? "Select Country to Enable" : ""}
      />
      <ReactHookFormDropdown
        {...generalFieldProps}
        disabled={!watch("country")}
        label="City"
        name="city"
        placeholder="Select City"
        data={
          citiesListRes?.data.map((item) => ({
            label: item.name,
            value: item.name,
          })) || []
        }
        info={!watch("country") ? "Select Country to Enable" : ""}
      />
      <ReactHookFormDropdown
        {...generalFieldProps}
        disabled={!watch("country")}
        label="Emirate"
        name="emirate"
        placeholder="Select Emirate"
        data={
          emiratesListRes?.data.map((item) => ({
            label: item.name,
            value: item.name,
          })) || []
        }
        info={!watch("country") ? "Select Country to Enable" : ""}
      />

      <FormInput {...generalFieldProps} label="Postal Code" name="postalCode" />
      <FormInput {...generalFieldProps} label="Address" name="address" />

      <FormHookDatePicker
        {...generalFieldProps}
        label="First Service Date"
        name="firstServiceDate"
      />
      <FormHookDatePicker
        {...generalFieldProps}
        label="Inactive Date"
        name="inactiveDate"
      />

      <FormControl>
        <FormLabel>Service Days</FormLabel>
        <Controller
          control={control}
          name="serviceDays"
          render={({ field }) => (
            <MultiSelect
              data={WEEK_DAYS}
              value={field.value}
              filterable={false}
              onChange={(e) => field.onChange(e.target.value)}
            />
          )}
        />
      </FormControl>
      <FormInput
        {...generalFieldProps}
        label="Requested By"
        name="requestedBy"
      />
      <div className="full-width-field">
        {" "}
        <FormControl>
          <FormLabel>Comments</FormLabel>
          <Controller
            control={control}
            name="comments"
            render={({ field }) => (
              <Textarea
                value={field.value}
                onChange={(e) => field.onChange(e.target.value)}
              />
            )}
          />
        </FormControl>
      </div>
    </>
  );
}
